module.exports = __webpack_public_path__ + "img/2.a98b5813.jpg";